import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { DynamicBG } from "~/components/blocks";
import { Margin, Title, Text, Button, Message } from "~/components/elements";
import * as S from "./styles";
import { scrollTop, parentScrollTop } from "~/utils/tools";
import { Creators as SignUpActions } from "~/store/modules/signUp/actions";
import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function VerifyEmail() {
  const mobile = isMobile();
  const dispatch = useDispatch();
  const userMail = useSelector((state) => state?.signUp?.sign?.userMail);

  const userHash = useSelector((state) => state?.signUp?.sign?.userHash);
  const resending = useSelector((state) => state?.signUp?.resend?.sending);
  const resendSuccess = useSelector((state) => state?.signUp?.resend?.success);
  const resendMessage = useSelector((state) => state?.signUp?.resend?.message);
  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  // const urlStorage = localStorage.getItem("url");
  // const url = urlStorage !== "null" ? urlStorage : window.location.origin;

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  const handleResend = () => {
    dispatch(SignUpActions.setResendData());
    dispatch(
      SignUpActions.resendConfirmEmail({
        ParticipanteHash: userHash,
        url: url,
        origin: origin,
      })
    );
  };

  useEffect(() => {
    scrollTop();
    parentScrollTop();
    if (!userMail) {
      history.push("/");
    }
    return () => {
      dispatch(SignUpActions.setSignUpData());
      dispatch(SignUpActions.setResendData());
    };
  }, [userMail, dispatch]);

  return (
    <>
      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <DynamicBG content>
          <S.PageHolder>
            <Margin mt={mobile ? 6 : 12} mb={mobile ? 1 : 2}>
              <S.TitleHolder>
                <Title as="1" levelDesktop="3" level="4">
                  Consulta tu correo electronico
                </Title>
              </S.TitleHolder>
            </Margin>
            <Margin mb={mobile ? 3 : 4}>
              <S.TextHolder>
                <Text level="1">
                  Se ha enviado un mensaje de confirmación al correo electrónico
                  registrado. Revisa tu bandeja de entrada para
                  <br className="deskOnly" /> validar tu registro.
                </Text>
              </S.TextHolder>
            </Margin>
            <Margin mb={4}>
              <S.TextHolder>
                <S.EmailHolder>
                  <Text level="1">
                    Confirmación enviada a:{" "}
                    <Text as="strong" level="1">
                      {userMail}
                    </Text>
                  </Text>
                </S.EmailHolder>
              </S.TextHolder>
            </Margin>
            <Margin mb={3}>
              <S.ButtonHolder>
                <Button
                  onClick={() => history.push("/login")}
                  id="confirmedButtonValidate"
                  color="primary"
                >
                  YA CONFIRME
                </Button>
              </S.ButtonHolder>
            </Margin>
            <Margin mb={mobile ? 9 : 12}>
              <S.TextHolder>
                <Text level="1">
                  ¿Aún no has recibido la <br className="mobileOnly" />{" "}
                  confirmación de registro?
                </Text>
                {!resending && (
                  <Text
                    as="anchor"
                    emphasis={false}
                    level="1"
                    onClick={() => handleResend()}
                    id="resendLinkValidate"
                  >
                    Haz clic aquí para reenviar el correo electrónico
                  </Text>
                )}
                {resendMessage && (
                  <Message variant={resendSuccess ? "success" : "error"}>
                    {resendMessage}
                  </Message>
                )}
              </S.TextHolder>
            </Margin>
          </S.PageHolder>
        </DynamicBG>
      </motion.div>
    </>
  );
}
